<!-- ═══════════════════════════════════════════════════════════════════════════
     Section: AI GUARDIAN LAYER
  ════════════════════════════════════════════════════════════════════════════ -->
<section class="ai" aria-labelledby="ai-heading">

    <!-- Holographic grid CSS overlay -->
    <div class="ai__grid-overlay" aria-hidden="true"></div>

    <div class="ai__container">
        <div class="ai__card">
            <div class="ai__inner">

                <!-- ─── Left column ────────────────────────────────────────────────── -->
                <div class="ai__left">

                    <!-- Badge -->
                    <div class="ai__badge">{{ 'ai_layer.badge' | translate }}</div>

                    <h2 class="ai__title" id="ai-heading">
                        <span>{{ 'ai_layer.title_1' | translate }}</span>
                        <span>{{ 'ai_layer.title_2' | translate }}</span>
                    </h2>

                    <p class="ai__body">{{ 'ai_layer.body' | translate }}</p>

                    <!-- Progress bars -->
                    <div class="ai__bars">

                        <div class="ai__bar-group">
                            <div class="ai__bar-meta">
                                <span class="ai__bar-label">{{ 'ai_layer.bar1_label' | translate }}</span>
                                <span class="ai__bar-value ai__bar-value--cyan">{{ 'ai_layer.bar1_value' | translate
                                    }}</span>
                            </div>
                            <div class="ai__bar-track">
                                <div class="ai__bar-fill ai__bar-fill--cyan" style="width:99.9%" role="progressbar"
                                    aria-valuenow="99" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>

                        <div class="ai__bar-group">
                            <div class="ai__bar-meta">
                                <span class="ai__bar-label">{{ 'ai_layer.bar2_label' | translate }}</span>
                                <span class="ai__bar-value ai__bar-value--lime">{{ 'ai_layer.bar2_value' | translate
                                    }}</span>
                            </div>
                            <div class="ai__bar-track">
                                <div class="ai__bar-fill ai__bar-fill--lime" style="width:92%" role="progressbar"
                                    aria-valuenow="92" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- ─── Right column: HUD visualization ──────────────────────────── -->
                <div class="ai__hud" aria-label="AI guardian status display">

                    <!-- Thick-border outer frame -->
                    <div class="ai__hud-frame">
                          <!-- Floating data tags -->
                            <div class="ai__hud-tag ai__hud-tag--tr">
                                <span class="ai__hud-tag-label ai__hud-tag-label--lime">{{ 'ai_layer.hud_hash_label' |
                                    translate }}</span>
                                <span class="ai__hud-tag-val">{{ 'ai_layer.hud_hash_value' | translate }}</span>
                            </div>
                        <div class="ai__hud-inner-frame">                          

                            <!-- Center stats -->
                            <div class="ai__hud-center">
                                <strong class="ai__hud-secure">{{ 'ai_layer.hud_secure' | translate }}</strong>
                                <span class="ai__hud-status">{{ 'ai_layer.hud_status' | translate }}</span>
                            </div>

                        </div>
                          <div class="ai__hud-tag ai__hud-tag--bl">
                                <span class="ai__hud-tag-label ai__hud-tag-label--magenta">{{
                                    'ai_layer.hud_latency_label' | translate }}</span>
                                <span class="ai__hud-tag-val">{{ 'ai_layer.hud_latency_value' | translate }}</span>
                            </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</section>
